import './QuantitativeObjectiveManagement.css';

import React, { useState } from 'react';
import { useContentContext } from '../../../layout/Layout';
import { findAvailableDateRange, getDisabledDateRanges, isIndicatorDimensional } from '../../components/helper';
import { showNotification } from '../../../b2b-common/Notification';
import Banner from '../../../b2b-common/Banner';
import DatesRange from '../../components/dates/DatesRange';
import { AreaIndicatorMainDetails, IndicatorDetails } from '../../components/area-indicators/AreaIndicatorCard';
import QuantitativeObjectiveEditForm from '../../components/objectives/QuantitativeObjectiveEditForm';
import QuantitativeObjectivesTable from './QuantitativeObjectivesTable';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';
import IndicatorWithTooltipInfo from '../../../b2b-indicators/components/IndicatorWithTooltipInfo';
import { Box } from '@mui/material';

export const CommonInfo = ({ areaIndicator }) => {
    const { t } = useB2BTranslation('b2b-plans');
    return (
        <Box className='objectives-management-modal-common-info' display={'flex'} flexDirection={'column'} gap={1.5} pb={4}>
            <div className='objectives-management-modal-area-indicator-area'>
                <Banner message={areaIndicator.area.areaName} sectionTittle={t('Area')} headingLevel='h4' underline={false} />
                <DatesRange startDate={areaIndicator.area.areaStartDate} endDate={areaIndicator.area.areaEndDate} />
            </div>
            <IndicatorWithTooltipInfo indicator={areaIndicator.indicatorDTO} />
            <AreaIndicatorMainDetails areaIndicatorData={areaIndicator} />
        </Box>
    );
};

const QuantitativeObjectiveManagement = ({ areaIndicator, onRefresh = null }) => {
    const { t } = useB2BTranslation('b2b-plans');
    const { setNotification } = useContentContext();
    const [showObjectiveEditForm, setShowObjectiveEditForm] = useState(false);

    const areaStartDate = areaIndicator.area.areaStartDate;
    const areaEndDate = areaIndicator.area.areaEndDate;
    const disabledDateRanges = getDisabledDateRanges(areaIndicator);
    const availableDates = findAvailableDateRange(areaStartDate, areaEndDate, disabledDateRanges);

    const [objectiveSelected, setObjectiveSelected] = useState(null);
    // console.log('availableDates:', availableDates);

    const handleObjectiveClick = (objective) => {
        // console.log('handleObjectiveClick:', objective);
        setObjectiveSelected(objective);
        setShowObjectiveEditForm(true);
    };

    const handleSavedQuantitativeObjective = (objective) => {
        // console.log('handleSevedQuantitativeObjective:', objective);
        showNotification(setNotification, t('Objective created or updated'), 'success', 3000);
        setShowObjectiveEditForm(false);
        onRefresh && onRefresh();
    };

    const handleDeletedQuantitativeObjective = (objective) => {
        // console.log('handleDeletedQuantitativeObjective:', objective);
        showNotification(setNotification, t('Objective deleted'), 'success', 3000);
        setShowObjectiveEditForm(false);
        onRefresh && onRefresh();
    };

    const handleNewObjective = () => {
        if (availableDates) {
            setObjectiveSelected(null);
            setShowObjectiveEditForm(true);
        } else {
            showNotification(setNotification, t('No available date range found'), 'warning', 3000);
        }
    };

    return (
        <>
            <CommonInfo areaIndicator={areaIndicator} />
            <QuantitativeObjectivesTable
                areaIndicator={areaIndicator}
                onObjectiveClick={handleObjectiveClick}
                onNewObjective={handleNewObjective}
            />
            {
                showObjectiveEditForm && !isIndicatorDimensional(areaIndicator.indicatorDTO) &&
                <QuantitativeObjectiveEditForm
                    objective={objectiveSelected}
                    planUUID={areaIndicator.area.plan.planUUID}
                    areaId={areaIndicator.area.areaId}
                    areaIndicatorId={areaIndicator.areaIndicatorId}
                    indicator={areaIndicator.indicatorDTO}
                    startDate={!objectiveSelected ? availableDates.availableStartDate : objectiveSelected.startDate}
                    endDate={!objectiveSelected ? availableDates.availableEndDate : objectiveSelected.endDate}
                    disabledDateRanges={getDisabledDateRanges(areaIndicator, objectiveSelected ? objectiveSelected.objectiveId : null)}
                    onSave={handleSavedQuantitativeObjective}
                    onDelete={handleDeletedQuantitativeObjective}
                    onCancel={() => { setShowObjectiveEditForm(false) }} />
            }
        </>);
};

export default QuantitativeObjectiveManagement;